import { useMemo } from 'react';
import { useCurrentYearAssumptionsQuery } from './api/useCurrentYearAssumptionsQuery';
import { OptionDTO } from './api/responseDTO.types';
import { OptionType } from '../OPL/Select/BaseSelect/types';
import { useCurrentYearAssumptionMutation } from './api/useCurrentYearAssumptionMutation';

const normalizeOptions = (options: OptionDTO[], extraLabel?: string): OptionType<number>[] => {
  return options.map(({ description, value, label }) => ({
    value,
    label: `${label}${extraLabel && value === 3 ? ` (${extraLabel})` : ''}`,
    subLabel: description,
  }));
};

export const useCurrentYearAssumptionSetting = () => {
  const queryInfo = useCurrentYearAssumptionsQuery();

  const saveCurrentYearAssumptionMutation = useCurrentYearAssumptionMutation();

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const {
      currentYearAssumptions,
      distributionsOptions,
      earningsOptions,
      contributionsOptions,
      taxesOptions,
      defaultCurrentYearAssumptions,
      higherLevelTaxesSetting,
    } = queryInfo.data;

    const higherLevelTaxSelected = taxesOptions.find(({ value }) => value === higherLevelTaxesSetting)
      ?.label;

    return {
      currentYearAssumptions,
      defaultCurrentYearAssumptions,
      distributionsOptions: normalizeOptions(distributionsOptions),
      earningsOptions: normalizeOptions(earningsOptions),
      contributionsOptions: normalizeOptions(contributionsOptions),
      taxesOptions: normalizeOptions(taxesOptions, higherLevelTaxSelected),
      higherLevelTaxesSetting,
    };
  }, [queryInfo]);

  return {
    ...queryInfo,
    data,
    action: { saveCurrentYearAssumptionMutation },
  };
};
